// Libs
import styled from 'styled-components';
// Hooks
import useTheme from 'hooks/useTheme';
// Components
import { Input } from 'antd';

const { Search, TextArea } = Input;

const InputStyled = styled(Input)`
	width: ${props => (props.width ? props.width : props.theme.textField.width)};
	margin: ${props =>
		props.margin ? props.margin : props.theme.textField.margin};
	min-height: ${props =>
		props.minHeight ? props.minHeight : props.theme.textField.minHeight};
	text-align: ${props =>
		props.textalign ? props.textalign : props.theme.textField.textAlign};
	&.ant-input {
		border: ${props => props.theme.textField.border};
		border-bottom: ${props => props.theme.textField.borderBottom};
		height: ${props =>
			props.height ? props.height : props.theme.textField.height};
		font-size: ${props =>
			props.fontSize
				? props.theme.fonts.size[props.fontSize]
				: props.theme.fonts.size.default};
		font-family: ${props =>
			props.fontFamily ? props.fontFamily : props.theme.fonts.family};
		font-weight: ${props =>
			props.fontWeight ? props.fontWeight : props.theme.textField.fontWeight};
		font-stretch: ${props =>
			props.fontStretch
				? props.fontStretch
				: props.theme.textField.fontStretch};
		font-style: ${props =>
			props.fontStyle ? props.fontStyle : props.theme.textField.fontStyle};
		line-height: ${props =>
			props.lineHeight ? props.lineHeight : props.theme.textField.lineHeight};
		letter-spacing: ${props =>
			props.letterSpacing
				? props.letterSpacing
				: props.theme.textField.letterSpacing};
		color: ${({ $newTheme }) => $newTheme._mediumEmphasisColor};
		background-color: transparent;
	}
	.ant-input[disabled] {
		background-color: ${({ $newTheme }) => $newTheme._disabledBackgroundColor};
	}
	&.ant-input[disabled] {
		background-color: ${({ $newTheme }) => $newTheme._disabledBackgroundColor};
	}
	&.ant-input-affix-wrapper {
		background-color: transparent;
	}
`;

const SearchStyled = styled(Search)`
	width: ${props => props.width && props.width};
	margin: ${props =>
		props.margin ? props.margin : props.theme.textField.margin};
	margin: ${props =>
		props.margin ? props.margin : props.theme.textField.margin};
	min-height: ${props =>
		props.minHeight ? props.minHeight : props.theme.textField.minHeight};
	&.ant-input {
		border: ${props => props.theme.textField.border};
		border-bottom: ${props => props.theme.textField.borderBottom};
		height: ${props =>
			props.height ? props.height : props.theme.textField.height};
		font-size: ${props =>
			props.fontSize
				? props.theme.fonts.size[props.fontSize]
				: props.theme.fonts.size.default};
		font-family: ${props =>
			props.fontFamily ? props.fontFamily : props.theme.fonts.family};
		font-weight: ${props =>
			props.fontWeight ? props.fontWeight : props.theme.textField.fontWeight};
		font-stretch: ${props =>
			props.fontStretch
				? props.fontStretch
				: props.theme.textField.fontStretch};
		font-style: ${props =>
			props.fontStyle ? props.fontStyle : props.theme.textField.fontStyle};
		line-height: ${props =>
			props.lineHeight ? props.lineHeight : props.theme.textField.lineHeight};
		letter-spacing: ${props =>
			props.letterSpacing
				? props.letterSpacing
				: props.theme.textField.letterSpacing};
		color: ${({ $newTheme }) => $newTheme._mediumEmphasisColor};
		background-color: transparent;
	}
	&.ant-input-search-icon {
		font-size: ${props =>
			props.fontSize
				? props.theme.fonts.size[props.fontSize]
				: props.theme.fonts.size.default};
		color: ${({ $iconColor, $newTheme }) => $iconColor ?? $newTheme._mediumEmphasisColor};
	}
	& .ant-input-search-button .anticon,
	& .ant-input-search-button .anticon-search {
		font-size: 20px !important;
		color: ${({ $iconColor, $newTheme }) => $iconColor ?? $newTheme._mediumEmphasisColor};
		transition: transform 0.15s ease, filter 0.15s ease;
	}
	& .ant-input-search-button .anticon svg,
	& .ant-input-search-button .anticon-search svg {
		width: 20px !important;
		height: 20px !important;
	}
	& .ant-input-search-button:hover .anticon,
	& .ant-input-search-button:hover .anticon-search {
		transform: scale(1.15) !important;
		filter: drop-shadow(0 0 1px rgba(255, 255, 255, 0.7)) !important;
	}
	& .ant-input-search-button {
		background: transparent !important;
		border-color: transparent !important;
		border-radius: 50% !important;
		transition: background-color 0.15s ease !important;
		&:hover {
			background: rgba(0, 0, 0, 0.18) !important;
			border-color: transparent !important;
		}
	}
`;

const TextAreaStyled = styled(TextArea)`
	margin: ${props =>
		props.margin ? props.margin : props.theme.textField.margin};
	min-height: ${props =>
		props.minHeight ? props.minHeight : props.theme.textField.minHeight};
	&.ant-input {
		border: ${props => props.theme.textField.border};
		border-bottom: ${props => props.theme.textField.borderBottom};
		height: ${props =>
			props.height ? props.height : props.theme.textField.textArea.height};
		font-size: ${props =>
			props.fontSize
				? props.theme.fonts.size[props.fontSize]
				: props.theme.fonts.size.default};
		font-family: ${props =>
			props.fontFamily ? props.fontFamily : props.theme.fonts.family};
		font-weight: ${props =>
			props.fontWeight ? props.fontWeight : props.theme.textField.fontWeight};
		font-stretch: ${props =>
			props.fontStretch
				? props.fontStretch
				: props.theme.textField.fontStretch};
		font-style: ${props =>
			props.fontStyle ? props.fontStyle : props.theme.textField.fontStyle};
		line-height: ${props =>
			props.lineHeight ? props.lineHeight : props.theme.textField.lineHeight};
		letter-spacing: ${props =>
			props.letterSpacing
				? props.letterSpacing
				: props.theme.textField.letterSpacing};
		color: ${({ $newTheme }) => $newTheme._mediumEmphasisColor};
		background-color: transparent;
	}
`;

export default {
	Input: props => {
		const { theme } = useTheme();
		return <InputStyled {...props} $newTheme={theme} />;
	},
	Search: ({ iconColor, ...props }) => {
		const { theme } = useTheme();
		return <SearchStyled {...props} $newTheme={theme} $iconColor={iconColor} />;
	},
	TextArea: props => {
		const { theme } = useTheme();
		return <TextAreaStyled {...props} $newTheme={theme} />;
	},
};
